__turbopack_context__.v({
  "dish": "RestaurantNewDishesPopup-module-sass-module__WFBpRW__dish",
  "dish-content": "RestaurantNewDishesPopup-module-sass-module__WFBpRW__dish-content",
  "dish-photo": "RestaurantNewDishesPopup-module-sass-module__WFBpRW__dish-photo",
  "dish-price": "RestaurantNewDishesPopup-module-sass-module__WFBpRW__dish-price",
  "dishes": "RestaurantNewDishesPopup-module-sass-module__WFBpRW__dishes",
  "subtitle": "RestaurantNewDishesPopup-module-sass-module__WFBpRW__subtitle",
});
